"use client";

import { Cta1Props } from "./props";
import styles from "./cta1.module.scss";
import { handleFormatStyleString } from "@/components/package-components/utils";

import {
  PlatformsIcon,
  PlatformsImage,
} from "@/components/package-components/non-editable/core";
import { useState } from "react";
import { MobileMenu } from "./mobile-menu";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { LeadCaptureForm } from "./lead-capture-form";
import useDeviceType from "@/components/package-components/hooks/useDeviceType";
import { BackButton } from "./back-button";

export function OldCta1(props: Cta1Props): JSX.Element {
  const pathname = usePathname();
  const { isMobile } = useDeviceType();

  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const [openLeadCaptureForm, setOpenLeadCaptureForm] = useState<
    "whatsapp" | "call" | null
  >(null);

  const isDetais = pathname?.includes(":") ?? false;

  const hasVehicle =
    pathname?.includes(":") && Object.keys(props.data).length === 0
      ? false
      : true;

  const handleOpenMenu = () => {
    setOpenMenu((prev) => !prev);
  };

  if (!hasVehicle) return <></>;

  if (!isMobile && isDetais) return <BackButton />;

  return (
    <>
      {props && props.styles && props.styles.value && (
        <style>
          {handleFormatStyleString(props.styles.value as string, props.id)}
        </style>
      )}
      <section
        id="containerCta1"
        className={`${styles.container} container-${props.id}`}
      >
        <div className={`${styles.wrapper} wrapper-${props.id}`}>
          {typeof props?.image != "undefined" && (
            <div
              className={`${styles["image-container"]} image-container-${props.id}`}
            >
              <Link
                href="/"
                className={`${styles["image-wrapper"]} image-wrapper-${props.id}`}
                rel="noreferer"
              >
                <PlatformsImage
                  width={385}
                  height={288}
                  priority
                  className={`${styles.image} image-${props.id}`}
                  src={(props?.image?.value ?? props?.image) as string}
                  alt=""
                />
              </Link>

              <Link
                href="/"
                rel="noreferer"
                className={`${styles["vendor-name-container"]} vendor-name-container${props.id}`}
              >
                <>
                  {props && typeof props.vendorName != "undefined" && (
                    <h1 className="whitespace-nowrap">
                      {typeof props.vendorName === "string"
                        ? props.vendorName
                        : props.vendorName.value}
                    </h1>
                  )}
                  {props && typeof props.shortDescription !== "undefined" && (
                    <span className="truncate block !max-w-[100%] md:max-w-full whitespace-nowrap text-ellipsis">
                      {typeof props.shortDescription === "string"
                        ? props.shortDescription
                        : props.shortDescription.value}
                    </span>
                  )}
                </>
              </Link>
            </div>
          )}
          <div className={`${styles["text-wrapper"]} text-wrapper-${props.id}`}>
            {typeof props.highlight != "undefined" && (
              <h2
                data-highlight={String(
                  props.highlight?.value ?? props.highlight
                )}
              >
                {String(props.heading?.value ?? props.heading)}
              </h2>
            )}
            {typeof props.description != "undefined" && (
              <div
                dangerouslySetInnerHTML={{
                  __html: String(props.description?.value ?? props.description),
                }}
                className={`${styles.description} description-${props.id}`}
              />
            )}
            {typeof props.action != "undefined" && (
              <div
                className={`${styles["button-container"]} button-container-${props.id}`}
              >
                <button
                  id="buttonCta1"
                  onClick={() => setOpenLeadCaptureForm("call")}
                  className={`${styles.button} button-${props.id}`}
                >
                  <PlatformsIcon
                    width={25}
                    height={25}
                    className={`${styles.icon} icon-${props.id}`}
                    icon="ph:phone"
                  />
                  Ligar Agora
                </button>

                <button
                  id="buttonCta1"
                  className={`${styles.button} button-${props.id} gtm_event_whatsapp`}
                  onClick={() => setOpenLeadCaptureForm("whatsapp")}
                >
                  <PlatformsIcon
                    width={25}
                    height={25}
                    className={`${styles.icon} icon-${props.id}`}
                    icon="ic:round-whatsapp"
                  />
                  Chamar no Whatsapp
                </button>
              </div>
            )}
          </div>
          <div className="px-[10px]">
            {!openMenu ? (
              <PlatformsIcon
                width={20}
                height={20}
                className={`${styles["menu-icon"]} menu-icon-${props.id}`}
                icon="lucide:menu"
                onClick={handleOpenMenu}
              />
            ) : (
              <PlatformsIcon
                width={20}
                height={20}
                className={`${styles["menu-icon"]} menu-icon-${props.id}`}
                icon="mingcute:close-line"
                onClick={handleOpenMenu}
              />
            )}
          </div>
        </div>
      </section>
      <MobileMenu ctaProps={props} open={openMenu} setOpen={setOpenMenu} />
      {openLeadCaptureForm != null && (
        <LeadCaptureForm
          ctaProps={props}
          openLeadCaptureForm={openLeadCaptureForm}
          setOpenLeadCaptureForm={setOpenLeadCaptureForm}
        />
      )}
    </>
  );
}
